module.exports = __webpack_public_path__ + "img/file_green.2581b7e1.svg";